/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateIncidentReference {
    getFixupPrototypeFunction() { return TemplateIncidentReference.fixupPrototype; }

    static newInstance(model: Partial<TemplateIncidentReference>): TemplateIncidentReference {
        let obj = Object.assign(new TemplateIncidentReference(), model);
        TemplateIncidentReference.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateIncidentReference>): TemplateIncidentReference {
        if (!model) return null;
        return TemplateIncidentReference.newInstance(<TemplateIncidentReference> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateIncidentReference) {
        if (!obj) return;

        models.TemplateIncidentReference.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateIncidentReference): boolean {
        Object.setPrototypeOf(obj, TemplateIncidentReference.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Integrated tool account id
     */
    integrated_tool_account_id: string;

    /**
     * Incident Id
     */
    incident_id: string;

}
